// FORCEP FÁBRICA — LANDING PROJECT REGISTRY
// Sources: Portfolio Forcep_25, FORCEP FABRICA DECK_2026, blackcard.forcep.art, bunker-mx26-web.vercel.app

const A = '/assets/landing';

export const PROJECTS = [
  {
    slug: 'black-card',
    name: 'BLACK CARD I/O',
    shortName: 'BLACK CARD',
    pillA: '2025',
    pillB: 'LIVE APP',
    category: 'SOFTWARE / DATA',
    taglineEs: 'Un motor para mapear el sabor humano',
    taglineEn: 'An engine to map human flavor',
    descEs: 'Plataforma web propietaria que mapea el sabor humano: curaduría de restaurantes y cocinas sobre mapa vivo de CDMX, perfiles, escáner y cuentas verificadas. Diseño, ingeniería full-stack y despliegue soberano por Forcep Fábrica.',
    descEn: 'Proprietary web platform that maps human flavor: curated restaurants over a living CDMX map, profiles, scanner and verified accounts. Design, full-stack engineering and sovereign deployment by Forcep Fábrica.',
    link: 'https://blackcard.forcep.art',
    images: [`${A}/black-card/black-card-1.webp`, `${A}/black-card/black-card-2.webp`, `${A}/black-card/black-card-3.webp`],
    accent: '#1A1A1A',
  },
  {
    slug: 'bakers',
    name: 'BAKERS',
    shortName: 'BAKERS',
    pillA: '2023',
    pillB: 'ECOSYSTEM',
    category: 'DIGITAL ECOSYSTEM',
    taglineEs: 'Cadena de suministro visual y comunidad automatizada',
    taglineEn: 'Visual supply chain & automated community ops',
    descEs: 'Construcción de una marca lifestyle de culto mediante visuales de alta fidelidad y despliegue sistemático de contenido. Integración de cadena de suministro visual y operaciones de comunidad. +240% engagement.',
    descEn: 'Built a cult lifestyle brand through high-fidelity visuals and systematic content deployment. Visual supply chain integration and community ops. +240% engagement.',
    link: null,
    images: [`${A}/bakers/bakers-1.webp`, `${A}/bakers/bakers-2.webp`, `${A}/bakers/bakers-3.webp`, `${A}/bakers/bakers-4.webp`, `${A}/bakers/bakers-5.webp`],
    accent: '#3B2F2F',
  },
  {
    slug: 'bunker-mx26',
    name: 'BUNKER MX26',
    shortName: 'BUNKER',
    pillA: '2026',
    pillB: 'BUILDING',
    category: 'VENTURE / HOSPITALITY',
    taglineEs: 'Club privado de hospitalidad a 10 min del Estadio Azteca',
    taglineEn: 'Private hospitality club, 10 min from Estadio Azteca',
    descEs: 'Venture propio para la Copa Mundial 2026: club de hospedaje y lounge de alta seguridad en Coyoacán. Proyecciones a puerta cerrada, barra de autor, membresías y estética retro-brutalista. Web, marca y operación in/out digital.',
    descEn: 'In-house venture for the 2026 World Cup: high-security lodging and lounge club in Coyoacán. Closed-door screenings, signature bar, memberships and retro-brutalist aesthetics. Web, brand and in/out-digital operation.',
    link: 'https://bunker-mx26-web.vercel.app/',
    images: [`${A}/bunker-mx26/bunker-mx26-1.webp`],
    accent: '#1F3D2B',
  },
  {
    slug: 'baja-flavors',
    name: 'BAJA FLAVORS',
    shortName: 'BAJA FLAVORS',
    pillA: '2024',
    pillB: 'EDITORIAL',
    category: 'EDITORIAL HIGH-END',
    taglineEs: 'La revista gastronómica de Baja California',
    taglineEn: "Baja California's gastronomic magazine",
    descEs: 'Socio estratégico de diseño desde el Vol. I. Dirección editorial, fotografía y arte para la revista gastronómica de Baja California. Alianza internacional con Land Rover (US/MX) y audiencia segmentada de 45,000 personas.',
    descEn: 'Strategic design partner since Vol. I. Editorial direction, photography and art for Baja California\u2019s gastronomic magazine. International alliance with Land Rover (US/MX), 45,000-person audience.',
    link: null,
    images: [`${A}/baja-flavors/baja-flavors-1.webp`, `${A}/baja-flavors/baja-flavors-2.webp`, `${A}/baja-flavors/baja-flavors-3.webp`, `${A}/baja-flavors/baja-flavors-4.webp`, `${A}/baja-flavors/baja-flavors-5.webp`, `${A}/baja-flavors/baja-flavors-6.webp`],
    accent: '#5A3A22',
  },
  {
    slug: 'la-perrona',
    name: 'LA PERRONA',
    shortName: 'LA PERRONA',
    pillA: '2024',
    pillB: 'IDENTITY',
    category: 'BRAND IDENTITY',
    taglineEs: 'Hecho perrón en Tijuana, Baja California',
    taglineEn: 'Made perrón in Tijuana, Baja California',
    descEs: 'Penetración de mercado e identidad visual full-stack para la salsa La Perrona. Codificación de la misión en un sistema de símbolos reconocible: pines metálicos con relieve, patrones y arquitectura de marca completa.',
    descEn: 'Market penetration and full-stack visual identity for La Perrona hot sauce. Mission codified into a recognizable symbol system: embossed metal pins, patterns and complete brand architecture.',
    link: null,
    images: [`${A}/la-perrona/la-perrona-1.svg`],
    accent: '#8E1F12',
  },
  {
    slug: 'tacotios',
    name: 'TACOTIOS',
    shortName: 'TACOTIOS',
    pillA: '2025',
    pillB: 'DOC SERIES',
    category: 'PRODUCCIÓN AUDIOVISUAL',
    taglineEs: 'Serie documental de episodios largos',
    taglineEn: 'Long-form documentary series',
    descEs: 'Producción audiovisual integral de una serie de episodios largos documentales: dirección, captura multicámara, sonido especializado, color y post-producción profesional bajo el tier cinema de Pure Fábrica.',
    descEn: 'Full audiovisual production of a long-form documentary episode series: direction, multicam capture, specialized sound, grading and professional post-production under the Pure Fábrica cinema tier.',
    link: null,
    images: [`${A}/tacotios/tacotios-1.webp`, `${A}/tacotios/tacotios-2.webp`, `${A}/tacotios/tacotios-3.webp`],
    accent: '#2B2B2B',
  },
  {
    slug: 'hosperation',
    name: 'HOSPERATION',
    shortName: 'HOSPERATION',
    pillA: '2023',
    pillB: 'PRODUCT',
    category: 'DISEÑO / FABRICACIÓN',
    taglineEs: 'Pin en zamak como distintivo de conferencias',
    taglineEn: 'Zamak pin as conference distinction',
    descEs: 'Colaboración con cadena hotelera: diseño, modelaje 3D y manufactura de pin en zamak como distintivo de conferencias. De blueprint funcional a producción física, Tijuana B.C.',
    descEn: 'Hotel-chain collaboration: design, 3D modeling and manufacturing of a zamak pin as conference distinction. From functional blueprint to physical production, Tijuana B.C.',
    link: null,
    images: [`${A}/hosperation/hosperation-1.webp`, `${A}/hosperation/hosperation-2.webp`, `${A}/hosperation/hosperation-3.webp`, `${A}/hosperation/hosperation-4.webp`, `${A}/hosperation/hosperation-5.webp`],
    accent: '#23303B',
  },
  {
    slug: 'fuego-santo',
    name: 'FUEGO SANTO',
    shortName: 'FUEGO SANTO',
    pillA: '2024',
    pillB: 'HIGH END',
    category: 'DISEÑO DE MENÚS',
    taglineEs: 'Mar y brasa: el contraste hecho menú',
    taglineEn: 'Sea & embers: contrast turned into a menu',
    descEs: 'Diseño de menús inspirado en el contraste entre el mar y las brasas para el restaurante high-end de Tijuana. Azules profundos, marrones cálidos y texturas rústicas que evocan la experiencia culinaria de alta gama.',
    descEn: 'Menu design inspired by the contrast between sea and embers for Tijuana\u2019s high-end restaurant. Deep blues, warm browns and rustic textures evoking the haute culinary experience.',
    link: null,
    images: [`${A}/fuego-santo/fuego-santo-1.webp`, `${A}/fuego-santo/fuego-santo-2.webp`, `${A}/fuego-santo/fuego-santo-3.webp`, `${A}/fuego-santo/fuego-santo-4.webp`, `${A}/fuego-santo/fuego-santo-5.webp`],
    accent: '#1E2F3C',
  },
  {
    slug: 'mexologia',
    name: 'MEXOLOGÍA',
    shortName: 'MEXOLOGÍA',
    pillA: '2023',
    pillB: 'EVENT + WEB',
    category: 'UX/UI / EVENTOS',
    taglineEs: 'Baja Cocktail Week — festival Oaxacalifornia',
    taglineEn: 'Baja Cocktail Week — Oaxacalifornia festival',
    descEs: 'Diseño web UX/UI, sistema de venta de boletos y branding del evento de mixología más importante del norte del país, parte del festival Oaxacalifornia 2023 en Club Campestre Tijuana.',
    descEn: 'UX/UI web design, ticketing system and event branding for the most important mixology event in northern Mexico, part of the Oaxacalifornia 2023 festival at Club Campestre Tijuana.',
    link: null,
    images: [`${A}/mexologia/mexologia-1.webp`, `${A}/mexologia/mexologia-2.webp`, `${A}/mexologia/mexologia-3.webp`, `${A}/mexologia/mexologia-4.webp`, `${A}/mexologia/mexologia-5.webp`],
    accent: '#274A33',
  },
  {
    slug: 'piedra-santa',
    name: 'PIEDRA SANTA',
    shortName: 'PIEDRA SANTA',
    pillA: '2023',
    pillB: 'MERCH',
    category: 'MERCHANDISING',
    taglineEs: 'Sangre oaxaqueña, corazón tijuanense',
    taglineEn: 'Oaxacan blood, Tijuana heart',
    descEs: 'Merchandising, impresión y diseño para la mezcalería de la Revolución, Tijuana. Sistema gráfico de líneas que mezcla Oaxaca y Tijuana alrededor del mezcal de autor.',
    descEn: 'Merchandising, print and design for the Revolución mezcal bar in Tijuana. A line-based graphic system blending Oaxaca and Tijuana around signature mezcal.',
    link: null,
    images: [`${A}/piedra-santa/piedra-santa-1.webp`, `${A}/piedra-santa/piedra-santa-2.webp`],
    accent: '#402718',
  },
  {
    slug: 'liquid-lust',
    name: 'LIQUID LUST',
    shortName: 'LIQUID LUST',
    pillA: '2023',
    pillB: 'SPEAKEASY',
    category: 'EDITORIAL / WEB',
    taglineEs: 'Speakeasy años 20 en el centro de Tijuana',
    taglineEn: "1920's speakeasy in downtown Tijuana",
    descEs: 'Diseño editorial y web para el speakeasy de mixología de autor: estética años 20, simetría Lladró y narrativa cinematográfica direct-to-consumer. 3.8x ROAS.',
    descEn: "Editorial and web design for the signature-mixology speakeasy: 1920's aesthetics, Lladró symmetry and cinematic direct-to-consumer narrative. 3.8x ROAS.",
    link: null,
    images: [`${A}/liquid-lust/liquid-lust-1.webp`],
    accent: '#5E1220',
  },
  {
    slug: 'photography',
    name: 'PHOTOGRAPHY',
    shortName: 'PHOTOGRAPHY',
    pillA: 'ONGOING',
    pillB: 'PURE FÁBRICA',
    category: 'CONTENT CREATION',
    taglineEs: 'Retratos, books y cobertura documental',
    taglineEn: 'Portraits, books and documentary coverage',
    descEs: 'Planificación y asesoría de imagen fotográfica: retratos, books, catálogos, editorial conceptual y cobertura de eventos con dirección de arte completa.',
    descEn: 'Photographic image planning and consulting: portraits, books, catalogs, conceptual editorial and event coverage with full art direction.',
    link: null,
    images: [`${A}/photography/photography-1.webp`, `${A}/photography/photography-2.webp`, `${A}/photography/photography-3.webp`, `${A}/photography/photography-4.webp`, `${A}/photography/photography-5.webp`, `${A}/photography/photography-6.webp`, `${A}/photography/photography-7.webp`],
    accent: '#222222',
  },
];

// The six names printed on the hero list (design 1:1); the rest live under MORE+
export const HERO_LIST_COUNT = 6;

export const getProject = (slug) => PROJECTS.find((p) => p.slug === slug);
export const getNextProject = (slug) => {
  const i = PROJECTS.findIndex((p) => p.slug === slug);
  return PROJECTS[(i + 1) % PROJECTS.length];
};

export const FORCEP = {
  isoDark: `${A}/logos/iso-negro.png`,
  isoLight: `${A}/logos/isotipo-blanco.png`,
  logoDark: `${A}/logos/logotipo-negro.png`,
  logoLight: `${A}/logos/logotipo-blanco.png`,
};
